import { DateFormat } from "sr/helpers/functions/DateFormat";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";

export const TableRow = ({item}) => {
   const transactionStatus = [
      {label:'Completed', value:'completed'},
      {label:'Pending', value:'pending'}
   ]
  return (
    <tr className="bg-white border-b  hover:bg-gray-50">
      
 <td className="px-6 py-4">                
   {item?.type ==='transfer' && 'Credited'} {item?.type ==='mint' || item?.type==='withdraw' && 'Debited'}

        </td>
        <td className="px-6 py-4">
<div>
   {getLabelByValue(item?.status, transactionStatus)}
</div>
        </td>
        <td className="px-6 py-4">
           { item?.type ==='transfer' && `+$${ Number(item?.amount - (item?.fee ? item?.fee : 0))?.toFixed(2)}`}{ item?.type ==='mint' || item?.type==='withdraw' && `-$${Number(item?.amount)?.toFixed(2)}`}

        </td>


        <td className="px-6 py-4">
{DateFormat(item?.createdAt)}
  </td>
    </tr>
     );
};
